export default {
  "nav.spreadsheet": "Hoja de cálculo",
  "nav.guides": "Guías",
  "nav.reviews": "Reseñas",
  "nav.shipping": "Envíos",
  "nav.safety": "Seguridad",
  "nav.faq": "Preguntas",
  "nav.visit": "Visitar sitio principal",

  "hero.badge": "Centro de recursos independiente",
  "hero.title": "USFans Spreadsheet — Tu guía completa para comprar en USFans",
  "hero.subtitle": "¿Buscas una hoja de cálculo de USFans, una guía de compras o información fiable antes de comprar? Estás en el lugar correcto. Explora recursos organizados, guías de productos, información de envío, consejos de almacén, recomendaciones de control de calidad, reseñas y guías de seguridad, todo en un centro fácil de navegar.",
  "hero.cta_primary": "Explorar USFans Spreadsheet",
  "hero.cta_secondary": "Leer la guía de USFans",
  "hero.trust": "Recurso independiente · Guías actualizadas · Información práctica · Enfocado en seguridad",
  "hero.search_placeholder": "Busca guías, envíos, control de calidad, cupones…",
  "hero.table_title": "Ejemplo de diseño de hoja",
  "hero.col_product": "Producto",
  "hero.col_category": "Categoría",
  "hero.col_reference": "Referencia",
  "hero.col_qc": "QC",
  "hero.col_shipping": "Envío",
  "hero.col_status": "Estado",
  "hero.item_1": "Artículo 01",
  "hero.item_2": "Artículo 02",
  "hero.item_3": "Artículo 03",
  "hero.item_4": "Artículo 04",
  "hero.qc_pending": "Pendiente",
  "hero.qc_passed": "Aprobado",
  "hero.ship_standard": "Estándar",
  "hero.ship_express": "Exprés",
  "hero.status_considering": "Considerando",
  "hero.status_ordered": "Pedido",
  "hero.status_received": "Recibido",

  "main.buy_now": "Comprar ahora",
  "main.tagline": "Explora toda la colección en nuestro sitio principal",
  "main.note": "Todos los enlaces de productos se abren en una pestaña nueva en nuestro sitio principal.",

  "category.title": "Comprar por categoría",
  "category.subtitle": "Salta directamente a cualquier categoría de productos en el sitio principal.",
  "category.dropdown_label": "Elige una categoría",
  "category.dropdown_placeholder": "Selecciona una categoría para visitar",

  "what_is.title": "¿Qué es una hoja de cálculo de USFans?",
  "what_is.body": "Una hoja de cálculo de USFans es un recurso estructurado que ayuda a los compradores a organizar y descubrir información de productos. Nuestro objetivo es facilitar la comprensión de esa información reuniendo guías prácticas, recursos de productos, explicaciones de envío, consejos de control de calidad y referencias útiles en un solo lugar.",
  "what_is.cta": "Explorar el centro de la hoja",

  "features.title": "Todo lo que necesitas saber sobre USFans",
  "features.subtitle": "Empieza aquí para entender la plataforma antes de comprar.",
  "features.spreadsheet.title": "USFans Spreadsheet",
  "features.spreadsheet.desc": "Explora recursos de la hoja y aprende a navegar la información de productos.",
  "features.review.title": "Reseña de USFans",
  "features.review.desc": "Entiende la plataforma, el proceso de compra, posibles ventajas y aspectos a considerar.",
  "features.shipping.title": "Costo de envío de USFans",
  "features.shipping.desc": "Aprende qué puede influir en los costos de envío y cómo comparar opciones disponibles.",
  "features.coupon.title": "Cupón de USFans",
  "features.coupon.desc": "Descubre dónde buscar promociones actuales y cómo verificar la información de descuentos.",
  "features.warehouse.title": "Almacén de USFans",
  "features.warehouse.desc": "Entiende el proceso de almacén, el almacenamiento, el control de calidad y la preparación del envío.",
  "features.legit.title": "¿Es USFans legítimo?",
  "features.legit.desc": "Revisa controles de seguridad prácticos y preguntas a considerar antes de usar un servicio de compras.",

  "guides.title": "Empieza con las guías más populares",
  "guides.subtitle": "Recursos seleccionados para ayudarte a comprar con confianza.",
  "guides.card1": "Guía de USFans Spreadsheet",
  "guides.card2": "Reseña de USFans",
  "guides.card3": "Guía de costos de envío de USFans",
  "guides.card4": "Guía de cupones de USFans",
  "guides.card5": "Guía del almacén de USFans",
  "guides.card6": "¿Es USFans legítimo?",

  "why.title": "¿Por qué usar este recurso?",
  "why.subtitle": "Creado para que tu investigación de compras sea más fácil y segura.",
  "why.1.title": "Información organizada",
  "why.1.desc": "Todo agrupado en una estructura clara y lógica.",
  "why.2.title": "Fácil para principiantes",
  "why.2.desc": "Explicaciones en lenguaje sencillo para todos los niveles.",
  "why.3.title": "Tablas comparativas",
  "why.3.desc": "Mira las opciones lado a lado antes de decidir.",
  "why.4.title": "Contenido actualizado",
  "why.4.desc": "Guías revisadas y actualizadas con regularidad.",
  "why.5.title": "Enfocado en seguridad",
  "why.5.desc": "Controles prácticos para comprar con responsabilidad.",
  "why.6.title": "Multilingüe",
  "why.6.desc": "Disponible en inglés, polaco, español y francés.",

  "compare.title": "Compara antes de decidir",
  "compare.body": "Los distintos métodos de compra, opciones de envío y flujos de trabajo pueden implicar diferentes costos, requisitos y riesgos. Usa nuestras guías comparativas para entender las diferencias antes de decidir.",
  "compare.cta": "Ver comparativas de USFans",

  "safety.title": "La seguridad primero",
  "safety.body": "Las compras en línea implican riesgos. Verifica siempre la información actual, los datos de pago, las políticas de envío y la información del vendedor antes de realizar una compra.",
  "safety.cta": "Leer la guía de seguridad de USFans",

  "homeArticle.title": "Guía más reciente",
  "homeArticle.subtitle": "Lee nuestra guía detallada para principiantes sobre USFans Spreadsheet.",
  "homeArticle.cta": "Leer la guía completa",
  "homeArticle.read_time": "Tiempo de lectura: 6 min",

  "faq.title": "Preguntas frecuentes",
  "faq.q1": "¿Qué es una hoja de cálculo de USFans?",
  "faq.a1": "Una hoja de cálculo de USFans es un recurso estructurado que ayuda a los compradores a organizar y descubrir información de productos en un solo lugar.",
  "faq.q2": "¿Es este el sitio web oficial de USFans?",
  "faq.a2": "No. Esta es una plataforma independiente de información y recursos. No estamos afiliados ni respaldados por ningún vendedor específico.",
  "faq.q3": "¿Cómo navego por los productos?",
  "faq.a3": "Usa el menú de categorías o los botones de arriba para ir directamente a cualquier categoría de productos en el sitio principal.",
  "faq.q4": "¿Publican precios o cupones?",
  "faq.a4": "Solo compartimos orientación general. Verifica siempre los precios, promociones y detalles de envío actuales directamente en el sitio principal.",

  "final.title": "¿Listo para explorar los recursos de USFans Spreadsheet?",
  "final.body": "Empieza con la hoja, compara tus opciones y aprende lo básico antes de comprar.",
  "final.cta_primary": "Explorar USFans Spreadsheet",
  "final.cta_secondary": "Visitar sitio principal",

  "footer.description": "Un centro de recursos multilingüe e independiente sobre USFans Spreadsheet. Compartimos guías, reseñas e información práctica de compras para ayudarte a tomar decisiones informadas.",
  "footer.resources": "Recursos",
  "footer.company": "Empresa",
  "footer.legal": "Legal",
  "footer.languages": "Idiomas",
  "footer.about": "Acerca de",
  "footer.editorial": "Política editorial",
  "footer.contact": "Contacto",
  "footer.disclaimer": "Aviso legal",
  "footer.privacy": "Privacidad",
  "footer.terms": "Términos",
  "footer.cookies": "Cookies",
  "footer.disclaimer_text": "Este es un sitio web de información independiente. No somos la tienda oficial de USFans y no vendemos productos directamente. Todos los enlaces de productos conducen al sitio principal.",
  "footer.copyright": "© 2026 USFans Spreadsheet Resource Hub. Todos los derechos reservados.",
};